import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import RenewIcon from '@mui/icons-material/Refresh';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
//import crypto from 'crypto';

const styles = (theme:Theme) => {
  const cfg:any = {
  master: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    //width: 200,
  },
  hide:{
    display:'none',
  },
};
return cfg;
}

class FAutoIDField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value || crypto.randomUUID().toUpperCase(), //'fefd8a30-f375-4c2b-8ac8-f935d3789071'
    };
  }

  componentDidMount(): void {
    const {value} = this.state;
    const {onChange} = this.props;
    if(typeof onChange === 'function') onChange(value);
  };

  // componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
  //   const {value} = this.state;
  //   const {onChange} = this.props;
  //   if(typeof onChange === 'function') onChange(value);
  // }

  disableEvent = (event:any) => {
    event.preventDefault();
  };

  handleChange = (event:any) => {
    // let value = event.target.value;
    // this.props.onChange(value);
    // this.setState({value});
    const {onChange} = this.props;
    let value = event.target.value;
    this.setState({value});
    if(typeof onChange === 'function') onChange(value);
  };

  onRenew = (event:any) => {
    const {onChange} = this.props;
    const value = crypto.randomUUID().toUpperCase();
    this.setState({value});
    if(typeof onChange === 'function') onChange(value);
  }

  render() {
    //const {id,label,divider,classes } = this.props;
    const {id,label,required,options,divider,classes } = this.props;
    const {value} = this.state;
    
    return (
      //<div className={classes.master}>
        <React.Fragment>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            required={required}
            multiline={true}
            minRows={1}
            fullWidth={true}
            className={classes.textField}
            onChange={this.handleChange}
            value={value}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/* <label htmlFor={xid}> */}
                  <IconButton 
                    color={'primary'}
                    onClick={this.onRenew}
                  >
                    <RenewIcon color={'inherit'}/>
                  </IconButton>
                  {/* </label> */}
                </InputAdornment>
              ),
            }}
            {...options}
            //value={this.state.value}
            // inputProps={
            //   { readOnly: true, }
            // }
            //onChange={this.handleChange}
            onKeyDown={this.disableEvent}
          />
        {divider && <Divider />}
        </React.Fragment>
      //</div>
    );
  }
}

FAutoIDField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(FAutoIDField);
